import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import '@adornis/calendar/calendar.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import type { Renderable } from '@adornis/functional-lit/renderable.js';
import { ChancenPermission } from '@chancenwerk/shared/permissions.js';
import '@chancenwerk/client/design/components/cr-data-view-table.js';
import '@chancenwerk/client/design/components/cr-dropdown-search-selection.js';
import { CrPage } from '@chancenwerk/client/design/components/cr-page.js';
import '@chancenwerk/work-tracking/client/chancen-component-work-tracking.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement board-page-work-tracking
 */
@customElement('board-page-work-tracking')
export class BoardPageWorkTracking extends CrPage {
  @property() eid = new RXController<Maybe<string>>(this, null);

  constructor() {
    super();
    this.label = 'Tätigkeiten Übersicht';
    this.description = 'Hier kannst du deine Tätigkeiten einsehen und vervollständigen';
    this.backRoute = '/work-tracking';
    this.permission = ChancenPermission.board.EDIT_WORK_TRACKING;
  }

  protected override content(): Renderable {
    return html`<chancen-component-work-tracking
      .eid=${this.eid.value}
      @title-change=${(e: ValueEvent<string>) => (this.label = e.detail.value)}
    ></chancen-component-work-tracking>`;
  }
}
